export const SET_PROJECT = 'SET_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const UPDATE_PHYSICAL_LOCATIONS = 'UPDATE_PHYSICAL_LOCATIONS';
export const SET_DOCUMENTS_ASSIGNED_TO_ME_COUNT = 'SET_DOCUMENTS_ASSIGNED_TO_ME_COUNT';
